import { createQueryKeys } from '../../factories';

const CATALOG_NAMESPACE = ['catalog'];

export const catalogQueryKeyFactory = createQueryKeys(CATALOG_NAMESPACE);
